/**
 * SOC checklist manual items service: consent, DME, emergency plan and HHAX setup are marked
 * through their own route (patientmr:phi:soc-checklist:*), not the demographics PUT, so
 * coordinators can complete them without demographics rights.
 */
import { apiClient } from '../api-client';
import { ApiResponse } from '../../dtos/common/api.dto';
import type { SocItemInputMap, SocItemName, SocItemsResponse } from '../../dtos/patientmr/socItems.dto';

export class SocItemsService {
  /** The four manual item fields plus the server-computed shared checklist. */
  static async get(patientId: string): Promise<SocItemsResponse> {
    const response: ApiResponse<SocItemsResponse> = await apiClient.get(`/patientmr/${patientId}/soc-items`);
    if (response.success && response.data) return response.data;
    throw new Error(response.error?.message || 'Failed to load the SOC checklist items');
  }

  /** Mark one item; the server writes only that item's fields. */
  static async update<K extends SocItemName>(patientId: string, item: K, input: SocItemInputMap[K]): Promise<SocItemsResponse> {
    const response: ApiResponse<SocItemsResponse> = await apiClient.put(`/patientmr/${patientId}/soc-items/${item}`, input);
    if (response.success && response.data) return response.data;
    throw new Error(response.error?.message || 'The item was not saved. Try again.');
  }
}
